import { useState } from "react";
import apiMaestras from "../api/Maestras/api-maestras";
import { Area } from "../models/Maestras/maestras.model";

export const useGestionAreas = () => {

    const [cantidadPaginas, setCantidadPaginas] = useState(10);
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    };

    const [areas, setAreas] = useState<Area[]>([])
    const obtenerAreas = async() => {
        try {
            const areas = await apiMaestras.obtenerAreas();
            setAreas(areas);
        } catch (error) {
            console.log(error)
        }
    }

    return {
        cantidadpaginas: cantidadPaginas,
        cambiarCantidadPaginas,
        obtenerAreas,
        areas
    } 
}
